'use es6';

import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import ChatAreaAlert from 'conversations-visitor-experience-components/visitor-widget/ChatAreaAlert';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import FilePickerLink from '../../../file-uploads/components/FilePickerLink';
import { SIZE_LIMIT_EXCEEDED, UPLOAD_ERROR, INVALID_FILE_TYPE } from '../../../file-uploads/constants/attachmentErrors';
import { MAX_FILE_SIZE } from '../../../file-uploads/constants/fileUploadsConstants';
import { getThreadId } from '../../operators/threadGetters';
import { jsx as _jsx } from "react/jsx-runtime";
const AttachmentErrorAlerts = ({
  attachmentsError,
  dismissAttachmentsError: dismiss,
  selectAttachmentFile: select,
  thread,
  trackInteraction
}) => {
  const dismissAttachmentsError = () => {
    dismiss({
      threadId: getThreadId(thread)
    });
  };
  const selectAttachmentFile = ({
    target: {
      files
    }
  }) => {
    if (!files || !files.length) {
      return;
    }
    const file = files.item(0);
    select({
      file,
      thread
    });
  };
  const trackTryAgain = () => {
    trackInteraction('retry-attachment-upload', {
      action: 'retry attachment upload'
    });
  };
  const title = (() => {
    switch (attachmentsError) {
      case SIZE_LIMIT_EXCEEDED:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cvVisitorUIAttachments.errors.fileSizeExceeded",
          options: {
            maxSize: I18n.formatSize(MAX_FILE_SIZE)
          }
        });
      case UPLOAD_ERROR:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cvVisitorUIAttachments.errors.uploadError"
        });
      case INVALID_FILE_TYPE:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cvVisitorUIAttachments.errors.invalidFileType"
        });
      default:
        return null;
    }
  })();
  return /*#__PURE__*/_jsx(ChatAreaAlert, {
    title: title,
    onClose: dismissAttachmentsError,
    link: /*#__PURE__*/_jsx(FilePickerLink, {
      onChange: selectAttachmentFile,
      onClick: trackTryAgain,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cvVisitorUIAttachments.tryAgain"
      })
    })
  });
};
AttachmentErrorAlerts.displayName = 'AttachmentErrorAlerts';
AttachmentErrorAlerts.propTypes = {
  attachmentsError: PropTypes.oneOf([SIZE_LIMIT_EXCEEDED, UPLOAD_ERROR, INVALID_FILE_TYPE]),
  dismissAttachmentsError: PropTypes.func.isRequired,
  selectAttachmentFile: PropTypes.func.isRequired,
  thread: RecordPropType('Thread').isRequired,
  trackInteraction: PropTypes.func.isRequired
};
export default AttachmentErrorAlerts;